export const LOGGER_NAME = 'snowplow';
